__turbopack_context__.v({
  "boundary": "ErrorBoundary-module-scss-module__iWMvkq__boundary",
});
